// src/components/layout/Layout.jsx
import React from "react";
import { Box, Container } from "@mui/material";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";

/**
 * Layout Component
 * Wraps all pages with common Navbar and Footer
 * Provides consistent structure across the application
 */
const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
      }}
    >
      {/* Navbar - appears on all pages */}
      <Navbar />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        {children}
      </Box>

      {/* Footer - appears on all pages */}
      <Footer />
    </Box>
  );
};

export default Layout;
